"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletedRequestPaymentTransport = exports.SourgumInvoicePaymentInput = exports.WaysteInvoicePaymentInput = exports.InvoicePaymentInput = exports.CustomerPortalPaymentRequestTransport = exports.CustomerPortalPaymentToken = exports.CustomerPortalPaymentRequest = exports.WaystePaymentRequestTransport = exports.WaystePaymentToken = exports.WaysteCreatePaymentRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const invoice_transport_1 = require("./invoice-transport");
exports.WaysteCreatePaymentRequest = typebox_1.Type.Object({
    // this is simply to verify the customer isn't seeing stale data
    // and isn't going to get charged more than they are expecting
    expectedAmount: typebox_1.Type.Integer({
        minimum: 1,
    }),
    receivables: typebox_1.Type.Array(typebox_1.Type.String({
        format: 'uuid',
    }), {
        minItems: 1,
    }),
});
exports.WaystePaymentToken = typebox_1.Type.Object({
    idempotencyKey: typebox_1.Type.String({ format: 'uuid' }),
    totalAmount: typebox_1.Type.Integer({
        minimum: 1,
    }),
    totalAdditionalPaymentFee: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    totalRemainingBalance: typebox_1.Type.Integer({
        minimum: 1,
    }),
    customerID: typebox_1.Type.String({
        format: 'uuid',
    }),
    haulerID: typebox_1.Type.String({
        format: 'uuid',
    }),
    payments: typebox_1.Type.Array(typebox_1.Type.Object({
        invoiceID: typebox_1.Type.String({
            format: 'uuid',
        }),
        receivableID: typebox_1.Type.String({
            format: 'uuid',
        }),
        orderID: typebox_1.Type.Optional(typebox_1.Type.String({
            format: 'uuid',
        })),
        fullInvoiceNumber: typebox_1.Type.String({
            minLength: 1,
        }),
        remainingBalance: typebox_1.Type.Integer({
            minimum: 1,
        }),
        status: typebox_1.Type.Optional(invoice_transport_1.InvoiceStatus),
        additionalPaymentFee: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
        total: typebox_1.Type.Integer({
            minimum: 1,
        }),
        paymentFeeID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    })),
});
exports.WaystePaymentRequestTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        token: typebox_1.Type.String({ minLength: 1 }),
    }),
    exports.WaystePaymentToken,
]);
// These are for Sourgum customer portal
exports.CustomerPortalPaymentRequest = exports.WaysteCreatePaymentRequest;
exports.CustomerPortalPaymentToken = typebox_1.Type.Omit(exports.WaystePaymentToken, ['haulerID']);
exports.CustomerPortalPaymentRequestTransport = typebox_1.Type.Intersect([
    typebox_1.Type.Object({
        token: typebox_1.Type.String({ minLength: 1 }),
    }),
    exports.CustomerPortalPaymentToken,
]);
exports.InvoicePaymentInput = typebox_1.Type.Object({
    paymentToken: typebox_1.Type.String(),
    stripeToken: typebox_1.Type.String(),
    stripeCustomer: typebox_1.Type.String(),
    amount: typebox_1.Type.Integer(),
});
exports.WaysteInvoicePaymentInput = typebox_1.Type.Object({
    email: typebox_1.Type.String({ format: 'email' }),
    stripeSourceToken: typebox_1.Type.String(),
    InvoicePaymentToken: typebox_1.Type.String(),
});
exports.SourgumInvoicePaymentInput = typebox_1.Type.Object({
    stripeSourceToken: typebox_1.Type.String(),
    InvoicePaymentToken: typebox_1.Type.String(),
});
/* export const InvoicePaymentToken = Type.Object({
  customerID: Type.String(),
  invoiceDetails: Type.Pick(CustomerInvoiceTransport, ['id', 'invoiceNumber', 'remainingBalance']),
}); */
exports.CompletedRequestPaymentTransport = typebox_1.Type.Object({
    chargeAmount: typebox_1.Type.Integer(),
    message: typebox_1.Type.String(),
});
//# sourceMappingURL=payment-request.js.map